<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table :headers='headers' :items='integracoes' sort-by='calories' class='elevation-1' :items-per-page="itemsPerPage" @update:items-per-page=" v => itemsPerPage = v" :search="search">
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn
                v-has-permission="['desenvolvedor']"
                color='primary'
                dark
                class='mb-2'
                @click="editItem(null)"
                v-text="$t('button.new')"
              />
              <ImportExportCadastroDB @import="searchAll()" />
            </v-toolbar>
            <SearchField v-model="tenantSearch" />
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{$t('button.edit')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>{{ $t('core.import_export.export') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.active='{ item }'>
            <v-icon color="primary" v-if="item.active">mdi-check-circle</v-icon>
            <v-icon color="red" v-else>mdi-close-circle</v-icon>
          </template>
          <template v-slot:item.nameGetParameters='{ item }'>
            <v-chip v-for="par in item.parametros"
              :key="par"
              class="mr-2"
            >
              {{par}}
            </v-chip>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import consultaDbService from '@/services/CadastroDbService'
import ImportExportService from '@/services/ImportExportService'
import IncludesIgnoreCase from '@/utils/IncludesIgnoreCase'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ImportExportCadastroDB from './ImportExportCadastroDB.vue'

export default {
  name: 'cadastroDbGrid',
  components: {
    LastModify,
    SearchField,
    ImportExportCadastroDB
  },
  data: () => ({
    search: '',
    tenantSearch: '',
    integracoes: []
  }),

  computed: {
    version () { return this.$versionable.versions.dbRegister },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('cadastrodb_per_page') ? parseInt(this.$cookies.get('cadastrodb_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('cadastrodb_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('keywords.id'),
          value: 'tenant',
          sortable: true,
          align: 'start',
          filter: id => IncludesIgnoreCase(id, this.tenantSearch)
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('check.active'),
          value: 'active',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },

  mounted () {
    this.searchAll()
  },

  methods: {

    searchAll () {
      consultaDbService.findAll().then((databases) => { this.integracoes = databases.data })
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        consultaDbService.delete(item)
          .then(() => this.searchAll())
          .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    },

    exportItem (item) {
      if (confirm(this.$t('warnings.confirm.export'))) {
        ImportExportService.export('cruddatabase', item.tenant)
          .then(() => this.$message.success(this.$t('warnings.success.export')))
          .catch(error => this.$message.error(`${this.$t('warnings.error.export')} : ${error}`))
      }
    }
  }
}
</script>
